import CloseIcon from '@mui/icons-material/Close';
import { Avatar, Box, Grid, Typography } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";
import { debounce } from 'lodash';
import moment from 'moment';
import { createRef, memo, useCallback, useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import AsyncDropDown from '../../../pages/new-ticket/LatestTicket/AsyncDrodown/AsyncDropDown';
import { iFormData } from '../../../pages/new-ticket/LatestTicket/Type';
import getTemplates from '../../../redux/actions/adminInterfaces/EmailTemplates';
import { getOrganisationsForDropdown } from '../../../redux/actions/CMDB/Organisation';
import { getTicketByID, quickUpdateTicket } from '../../../redux/actions/TicketsManagement/TicketsManagement';
import { IState } from "../../../redux/reducers/rootReducers";
import timeSpanToReadbleFormat from '../../../util/timeSpanToReadbleFormat';
import BasicButton from '../../common/button/BasicButton';
import CustomSelect from '../../common/customSelect/CustomSelect';
import CustomFormLabel from '../../common/form-label/CustomFormLabel ';
import Radio from '../../common/radio/Radio';
import { TextBoxLatest } from '../../common/TextBoxLatest/TextBoxLatest';
import { handleTime, returnFormValues } from '../../helpers/helperFunctions';
import { LabelFieldBox } from '../../postLogin/MyLicenses';
import CloseCategoryOption from './CloseCategoryOption';
import { convertToTimeSpan } from '../../../pages/new-ticket/AddUpdate';
import EffortField from '../../MobileComponents/MobileUtilities/EffortField';
import TicketAdditionalField from './TicketAdditionalField';
import DescriptionViewer from '../../../util/DescriptionViewer';


export const GenrateTemplateField = ({
  isEmailShow,
  handleSelectChange,
  value,
  setEmailChecked,
  emailChecked,
  template,
  setTemplate,
  error,
}: {
  isEmailShow: any;
  handleSelectChange: any;
  value: any;
  setEmailChecked: any;
  emailChecked: any;
  template: any;
  setTemplate: any;
  error: any;
}) => {
  // useEffect(() => {
  //   console.log("isEmailShow", isEmailShow);
  // }, [isEmailShow]);

  return (
    <>
      <>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "start",
            alignItems: "center",
            marginTop: "10px",
          }}
        >
          <Radio
            setEmailChecked={setEmailChecked}
            emailChecked={emailChecked}
            name={"send-email-checkbox"}
          />
          <span style={{ fontSize: "14px" }}>Send email</span>
        </div>
        {emailChecked && (
          <>
            <span style={{ fontSize: "14px" }}>
              Select a template
              <span style={{ color: "red" }}>*</span>
            </span>
            <CustomSelect
              isOpen={false}
              placeholder="Select a Template"
              width={"100%"}
              name="template"
              isColor={false}
              isDisabled={false}
              isError={error?.errors?.template ? true : false}
              helperText={error?.errors?.template||""}
              defaultValue={value}
              options={template.filter((i:{isActive:boolean})=>i.isActive)}
              handleChange={(e: any) => {
                handleSelectChange(e, "template");
              }}
              isMulti={false}
            />
          </>
        )}
      </>
    </>
  );
};



interface ResolvePopupProps {
  ticketIdWithStatusID: any;
  statusObj: any;
}
const ResolvePopup = memo((props: ResolvePopupProps) => {
  const { ticketIdWithStatusID, statusObj } = props;
  console.log("statusObj",ticketIdWithStatusID);
  
  const classes = useStyles();
  const dispatch = useDispatch();
  const [errorObj, setErrorObj] = useState<any>({});
  const [curentTicket, setCurentTicket] = useState<any>({});
  const [emailChecked, setEmailChecked] = useState<boolean>(false);
  const [template, setTemplate] = useState<any>([]);
  const [selectedTemplate, setSelectedTemplate] = useState<any>(null);
  const [buttonDisabled, setButtonDisabled] = useState<any>(false);
  const [outcomeCategoryId, setOutcomeCategoryId] = useState<any>(null);
  const [ticketAdditionalField,setticketAdditionalField]= useState<any>({})
  const [additionalFields,setAdditionalFields]= useState<any>({})
   const [additionalFieldserror,setAdditionalFieldserror]= useState<any>({})
  const [webFormVal, setWebFormVal] = useState('');
  const TemplatesList = useSelector(
    (state: IState) => state?.EmailTemplatesReducer?.AllEmailTemplates
  );

  useEffect(() => {
    dispatch(getTemplates());
  }, []);

  useEffect(() => {
    // console.log("curentTicketpoiuyt", TemplatesList);
    handleTemplateBasesOnstatus();
  }, [statusObj?.[ticketIdWithStatusID?.statusId]?.name]);

  const handleSelectChange = (e: unknown, type: string) => {
    setSelectedTemplate(e);
    setErrorObj({
      ...errorObj,
      template : false
    });
  };

  const handleTemplateBasesOnstatus = () => {
      const currentStatus = statusObj?.[ticketIdWithStatusID?.statusId]?.name;
      const statusActionMap: Record<string, string> = {
        NewtoMe: "Assign",
        Resolved: "Resolve",
        Closed: "Close"
      };

      let action = statusActionMap[currentStatus];

      // If action is undefined, do nothing
      if (!action) {
        action = "AddUpdate";
      };

      handleSelectChange(null, "template");

      const filteredTemplates = TemplatesList.filter((ele: any) => ele.actions === action);

      setTemplate(filteredTemplates);

      if (filteredTemplates.length === 1) {
        handleSelectChange(filteredTemplates[0], "template");
      } else {
        handleSelectChange(null, "template");
      }
    };

  useEffect(() => {
    if (!ticketIdWithStatusID.ticketId) return;
    handleTime.cancel();
    handleTime.setup(() => {
      dispatch(getTicketByID(ticketIdWithStatusID.ticketId, getTicketByIDCB))
    },200)
  }, [ticketIdWithStatusID])
  const getTicketByIDCB = (resStatus: string, res: any) => {
    if (resStatus !== "0") return;
    console.log("===============",res?.ticketLogs?.ticketType?.id);
    
    setCurentTicket(res)
    console.log("+++++++++++++++++++++",curentTicket?.ticketLogs?.ticketType?.id);
    
  }
  const onCloseHandler = useCallback(() => {
    setErrorObj({});
    setButtonDisabled(false);
    setEmailChecked(false);
    setCurentTicket({});
    dispatch({
      type: "RESOLVE_POPUP_INFO",
      payload: {}
    })
  }, [])


  const quickUpdateTicketCB = (res: any) => {
    // console.log("quickUpdateTicketCB", res);
    setButtonDisabled(false)
    if (res === "failure") return
    if (emailChecked) {
      dispatch({
        type: "SEND_EMAIL_VIEW",
        payload: {
          ...res,
          template: selectedTemplate,
          addUpdate: true
        },
      });
    }
    onCloseHandler();
  }


  const { contacts, title, description, agent, ticketStatus, group, openDateTime, slaRemaining, dueDateTime, slaRemainingInTicks }: any = curentTicket?.ticketLogs || {};


console.log('description',description);

type FormValue = string | boolean | string[];

function getFormValuesFromContainer(container: HTMLElement | null): Record<string, FormValue> {
  const values: Record<string, FormValue> = {};
  if (!container) return values;

  // Select inputs, selects, textareas with name attribute
  const elements = container.querySelectorAll<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>(
    'input[name], select[name], textarea[name]'
  );

  elements.forEach(el => {
    const { name, type, value, checked, multiple }:any = el;
    if (!name) return;

    if (type === 'checkbox') {
      values[name] = checked;
    } else if (type === 'radio') {
      if (checked) values[name] = value;
    } else if (multiple && el.tagName.toLowerCase() === 'select') {
      const select = el as HTMLSelectElement;
      values[name] = Array.from(select.selectedOptions).map(option => option.value);
    } else {
      values[name] = value;
    }
  });

  return values;
}


function validateRequiredFields(container: HTMLElement) {
  const errorFields: string[] = [];

  // Find all label holders — these seem to be spans with class 'app-field-label' in your markup
  const labels = container.querySelectorAll('span.app-field-label');

  labels.forEach(label => {
    // Check if label contains a red asterisk span
    const requiredAsterisk = label.querySelector('span[style*="color: red"]');
    if (requiredAsterisk) {
      // This is a required field label
      
      // The input/textarea is likely to be located in the nearby DOM,
      // for example, siblings or within the same wrapping parent container
      // In your markup, the input is in a sibling div with input or textarea inside
      
      // Let's get the nearest ancestor with class 'common-new-input-holder'
      const inputHolder = label.closest('.common-new-input-holder');
      if (!inputHolder) return; // safety check

      // Try to find input or textarea inside inputHolder
      const inputElem = inputHolder.querySelector('input, textarea,Date Field ') as (HTMLInputElement | HTMLTextAreaElement | null);
      if (inputElem) {
        const val = inputElem.value.trim();
        if (!val) {
          // Field is empty but required
          // Use label text to identify field name for error message
          const fieldName = label.textContent?.replace('*', '').trim() || "Unnamed field";
          errorFields.push(fieldName);
        }
      }
    }
  });

  return errorFields;
}



  const validateWebForm = (enteredVal: any = {}) => {
          console.log("enteredVal", enteredVal);
          let errObj: any = {
            hasError: false,
          };

        additionalFields[0]?.webformFieldList?.forEach((i: any) => {
        if(i?.isMandatory){ 
          if(i?.fieldType=="CheckBox"&& !enteredVal[i?.fieldLabel]){
            errObj[i?.fieldId]=`Please Enter ${i?.fieldLabel}`
            errObj.hasError = true;
            
          }
          else if(i?.fieldType =="DropDown" && ((enteredVal[i?.fieldLabel] == "pleaseSelect") || (enteredVal[i?.fieldLabel] == "please select") )){
          errObj[i?.fieldId]=`Please Select ${i?.fieldLabel}`
            errObj.hasError = true;
          }
        else if( enteredVal[i?.fieldLabel]?.length === 0) {
            errObj[i?.fieldId]=`Please Enter ${i?.fieldLabel}`
            errObj.hasError = true;
          }
        }
    });
    setAdditionalFieldserror(errObj)
    return errObj;
  };

  const onSubmit = (event: any) => {
 
 event.preventDefault();
  if (buttonDisabled) return;
  // statusName == "Resolved" ||statusName == "Closed"
  const additionalFieldsContainer = event.currentTarget.querySelector('#ticket-additional-fields');
  if (!additionalFieldsContainer) {
    console.warn("Container with id 'ticket-additional-fields' not found");
    return;
  }
    const additionalFieldsContainerForm = event.currentTarget.querySelector('#ticket-additional-fields-form');
    
    
    const formDataAdditionalField = 
     (statusName === "Resolved" || statusName === "Closed") ?
     new FormData(additionalFieldsContainerForm)
      : null;
    
    const AdditionalFielddata: any = {};

    formDataAdditionalField?.forEach((value, key) => {
    if (key.startsWith("checkBox_")) {
        let keyarray = key.split("_");
        const groupKey = keyarray[1]; // e.g. part after "checkBox_"
        if (!AdditionalFielddata[groupKey]) {
          AdditionalFielddata[groupKey] = value.toString();
        } else {
          AdditionalFielddata[groupKey] += ',' + value.toString();
        }
      } else {
        AdditionalFielddata[key] = value.toString();
      }
    });

    console.log("AdditionalFielddata =======",AdditionalFielddata);
    const AdditionalFielderrors = (statusName == "Resolved" ||statusName == "Closed")  && validateWebForm(AdditionalFielddata);
  
   setticketAdditionalField(AdditionalFielddata)

    // -------------------
    const formData = new FormData(event.currentTarget);
    event.preventDefault();
      if (!event.currentTarget) return
      const data: iFormData = returnFormValues(event.currentTarget)
      const validation = validationHelper(data, statusObj?.[ticketIdWithStatusID?.statusId]?.name)
      if (!validation.isValid) {
         setButtonDisabled(false); 
        setErrorObj(validation.errors);
        return;
      }
      console.log("errorserrors",AdditionalFielderrors);
      if(AdditionalFielderrors?.hasError){
         setButtonDisabled(false); 
        return
      }
      dispatch(quickUpdateTicket(
        {
          ...curentTicket, ticketLogs: {
            ...curentTicket?.ticketLogs,
            note: data?.note || null,
            statusId: ticketIdWithStatusID?.statusId,
            ticketStatus: statusObj?.[ticketIdWithStatusID?.statusId],
            effort:convertToTimeSpan("", data?.hours,data?.mins),
            contactOrganisationId: curentTicket?.ticketLogs?.contactOrganisationId || +data?.contactOrganisationId || 0,
            thirdPartyRefNo: curentTicket?.ticketLogs?.thirdPartyRefNo || data?.thirdPartyRefNo || null,
            outComeCategoryId: outcomeCategoryId?.id || outcomeCategoryId || null,
           "ticketAdditionalField": AdditionalFielddata
          }
        },
        quickUpdateTicketCB
      ));
      onCloseHandler()
  }
  const statusName = statusObj?.[ticketIdWithStatusID?.statusId]?.name;
  return (
    <>
      {ticketIdWithStatusID?.ticketId > 0 && (
        <Box className={`${classes.popupHolder} ${classes.textWithSpanTitle}`}>
          <Box className="modal-dialog">
            <Box className="modal-content">
              <Box className="modal-header">
                <Box className="row m-0 rsolveTicketTitle txt-ellipsis align-items-center gap15">
                  <Avatar
                    className="sml-avatar"
                    sx={{ height: 25, width: 25 }}
                    alt={contacts?.name || "PP"}
                    src={`${contacts?.profilePicturePath || ""}`}
                  />
                  <Typography className="txtCapitalize ">
                    <span>
                      <span className="txt-primary">
                        #{ticketIdWithStatusID?.ticketId}{" "}
                      </span>{" "}
                      {/* {title}{" "} */}
                    </span>
                  </Typography>
                </Box>
                <Typography className="cursor-pointer" onClick={onCloseHandler}>
                  <CloseIcon className="cursor-pointer" />
                </Typography>
              </Box>
              <Box className="modal-body resolve-popup">
                <Box className="p-1 pr-0">
                  <Grid container spacing={1}>
                    <Grid item xs={12} md={4}>
                      <LabelFieldBox label={"Subject"} value={title} />
                        <Box>
                            <DescriptionViewer value={description} />
                        </Box>
                      <LabelFieldBox
                        label={"Primary Contact"}
                        value={contacts?.name}
                      />
                      <LabelFieldBox label={"Group"} value={group?.name} />
                      <LabelFieldBox
                        label={"Agent"}
                        value={`${agent?.firstName || ""} ${
                          agent?.lastName || ""
                        }`}
                      />
                      <LabelFieldBox
                        label={"Open Date"}
                        value={moment(openDateTime).format("L LT")}
                      />
                      <LabelFieldBox
                        label={"Due Date"}
                        value={moment(dueDateTime).format("L LT")}
                      />
                    </Grid>
                    <Grid item xs={12} md={8} sx={{p:1}}>
                      {slaRemaining && (
                        <LabelFieldBox
                          className={`sla ${
                            slaRemainingInTicks <= 0
                              ? "txt-danger"
                              : "txt-success"
                          }`}
                          label={"SLA"}
                          value={
                            ticketStatus?.name === "OnHold"
                              ? "On-Hold"
                              : timeSpanToReadbleFormat(slaRemaining, "ss")
                          }
                        />
                      )}
                      <form onSubmit={onSubmit}>
                        {curentTicket?.ticketLogs?.id && (
                          <>
                            <ThirdPartyForm
                              curentTicket={curentTicket}
                              statusName={statusName}
                              errorObj={errorObj}
                              unsetError={setErrorObj}
                            />
                           
                            {/* <CloseCategoryOption
                              ticketTypeId={
                                curentTicket?.ticketLogs?.ticketTypeId
                              }
                            /> */}
                           <br></br>
                            {statusName !== "ThirdParty" &&<>
                              <CloseCategoryOption
                                  ticketTypeId={curentTicket?.ticketLogs?.ticketTypeId}
                                  onSelectOutcome={(outcomeCategoryId) => {
                                    setErrorObj({
                                      ...errorObj,
                                      outcomeCategoryId : false
                                    });
                                    setOutcomeCategoryId(outcomeCategoryId); // Save the selected outcome category ID
                                  } } 
                                  outComeCategoryId={curentTicket?.ticketLogs?.outComeCategoryId}   
                                  isError={errorObj?.outcomeCategoryId ? true : false}
                              />
                              
                            </>
                            }
                            
                          {/* <Box sx={{display:'contents', mt:2}}  id ="ticket-additional-fields" >
                          
                          
                           </Box> */}

                        <Box sx={{ width: '100%', mt: 2 }}>
                            <Box id ="ticket-additional-fields" 
                               > 
                              {
                             ( statusName == "Resolved" ||statusName == "Closed" ) &&
                              (
                                 <form id ="ticket-additional-fields-form" >
                                    <TicketAdditionalField  
                                    ticketTypeId= {curentTicket?.ticketLogs?.ticketType?.id}
                                    setAdditionalFields={setAdditionalFields}
                                    additionalFieldserror={additionalFieldserror}
                                    savedsetAdditionalFields = {curentTicket?.ticketLogs?.ticketAdditionalField}/>
                               </form>
                              )}
                              </Box>
                            </Box>


                             <Box sx={{mt:2}}><EffortField /></Box>
                            <div style={{ width: "100%" }}>
                              <GenrateTemplateField
                                setEmailChecked={setEmailChecked}
                                emailChecked={emailChecked}
                                isEmailShow={false}
                                handleSelectChange={handleSelectChange}
                                value={selectedTemplate}
                                template={template}
                                setTemplate={setTemplate}
                                error={{
                                  isValid: errorObj?.template ? true : false,
                                  errors: errorObj,
                                }}
                              />
                            </div>
                            <Box
                              className="pt-2 text-right"
                              style={{ marginTop: "6px" }}
                            >
                              <BasicButton
                                type={"button"}
                                label={"Close"}
                                size="small"
                                variant={"outlined"}
                                onClick={onCloseHandler}
                              />{" "}
                              &nbsp; &nbsp;
                              <BasicButton
                                disabled={buttonDisabled}
                                type={buttonDisabled ? "button" : "submit"}
                                label={buttonDisabled ? "Loading..." : "Submit"}
                                size="small"
                                variant={"contained"}
                              />
                            </Box>
                          </>
                        )}
                      </form>
                    </Grid>
                  </Grid>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      )}
    </>
  );

})

const ThirdPartyForm = (props: any) => {
  const { errorObj, unsetError, statusName, curentTicket } = props;
  const noteRef: any = createRef();
  const thirdPartyNumRef: any = createRef();
  const dispatch = useDispatch();
  const promiseOptionsForOrg = debounce((inputValue: any, callback: any) => {
    if (inputValue.length > 2) {
      dispatch(getOrganisationsForDropdown(inputValue, callback, true))
    } else {
      callback([]); // Pass options to the callback
    }
  }, 300);
  const [contactOrgVal, setContactOrgVal] = useState(null)
  const resetErrors = debounce((key: string) => {
    unsetError({
      ...errorObj,
      [key]: false
    });
  }, 300)
  useEffect(() => {
    // console.log("curentTicketpoiuyt", curentTicket)
    if (thirdPartyNumRef?.current) {
      thirdPartyNumRef.current.value = curentTicket?.ticketLogs?.thirdPartyRefNo || "";
    }
    if (curentTicket?.ticketLogs?.contactOrganisation?.name) {
      setContactOrgVal({
        ...curentTicket?.ticketLogs?.contactOrganisation,
        label: curentTicket?.ticketLogs?.contactOrganisation?.name || "",
        value: curentTicket?.ticketLogs?.contactOrganisation?.name || "",
      })
    }
  }, [curentTicket])
  return (<>
    {statusName === "ThirdParty" &&
      <Box className="thirdPartyBox-popup" sx={{mb: 2 }}>
        <CustomFormLabel classNames='sml-txt' labelName={"Please Enter Third Party Organisation"} isMandotary={true} />
        <AsyncDropDown
          promiseOptions={promiseOptionsForOrg}
          name="contactOrganisationId"
          placeHolder="Search and select a Third Party"
          handleChange={(e: any) => {
            resetErrors("contactOrganisationId")
            setContactOrgVal(e)
          }}
          isError={errorObj?.contactOrganisationId ? true : false}
          defaultValue={contactOrgVal}
          customClassNames="sml-txt-dropdown thirdparty-dropdown"
        />
        <p style={{ fontSize: "12px", margin: 0, color: "#c8c8c8" }}>* You need at least 3 characters to search</p>
        {errorObj?.contactOrganisationId && <CustomFormLabel classNames='sml-txt txt-danger' labelName={errorObj?.contactOrganisationId} isMandotary={false} />}

        <TextBoxLatest
          placeholder="Third Party Ref Number"
          ref={thirdPartyNumRef}
          name='thirdPartyRefNo'
          parentClassNames=''
          title='Please Enter Third Party Ref Number'
          isError={errorObj?.thirdPartyRefNo ? true : false}
          errorMsg={errorObj?.thirdPartyRefNo || "Please Enter"}
          onchangeHandler={() => { resetErrors("thirdPartyRefNo") }}
          isMandotary={true}
        />
      </Box>
    }

    <TextBoxLatest
      placeholder="Please Enter"
      ref={noteRef}
      name='note'
      title={statusName !== "ThirdParty" ? 'Please Enter Resolve Notes' : 'Notes'}
      multiline={true}
      parentClassNames=''
      isError={errorObj?.note ? true : false}
      errorMsg={errorObj?.note || "Please Enter"}
      onchangeHandler={() => { resetErrors("note") }}
      isMandotary={statusName === "Resolved"}
    />
  </>)
}


const validationHelper = (payload: iFormData, status: string) => {
  console.log("validationHelper", payload, status)
  let temp: any = {
    isValid: true,
    errors: {}
  }
  if (status !== "Resolved") {
    if (!payload?.thirdPartyRefNo?.trim || payload?.thirdPartyRefNo?.trim() === "") {
      temp.isValid = false;
      temp.errors.thirdPartyRefNo = "Please Enter Third Party Ref Number";
    }
    if (!payload?.contactOrganisationId?.trim || payload?.contactOrganisationId?.trim() === "") {
      temp.isValid = false;
      temp.errors.contactOrganisationId = "Please Choose Third Party Organisation";
    }
  } else {
    if (!payload?.note?.trim || payload?.note?.trim() === "") {
      temp.isValid = false;
      temp.errors.note = "Please Enter Resolve Notes";
    }
    if (payload?.closeCategory === "") {
      temp.isValid = false;
      temp.errors.outcomeCategoryId = "Please Choose Outcome";
    }
  }

  if(payload["send-email-checkbox"] === "on" && payload.template === ""){
    temp.isValid = false;
    temp.errors.template = "Please Choose this field";
  }
  return temp;
}
const useStyles = makeStyles(() =>
  createStyles({
    popupHolder: {
      position: "fixed",
      top: 0,
      left: 0,
      background: "#0005",
      width: "100vw",
      height: "100%",
      overflow: "hidden",
      zIndex: 1200,
      "& .modal-dialog": {
        display: "flex",
        width: "100vw",
        height: '100%',
        justifyContent: "center",
        alignItems: "center",
      },
      "& .modal-header": {
        display: "flex",
        alignItems: "center",
        padding: "20px",
        justifyContent: "space-between",
        borderBottom: "1px solid #ddd",
        paddingBottom: "10px"
      },
      "& .modal-body": {
        maxHeight: "calc(100vh - 200px)",
        overflowY: "scroll",
        padding: "0px"
      },
      "& .modal-body > div": {
        margin: "0 !important",
        // maxWidth: "calc(100% - 15px)"
      },
      "& .modal-content": {
        background: "#fff",
        width: "100%",
        maxWidth: "65vw",
        borderRadius: "5px",
        //padding: "20px",
        "& img.Contactprofile": {
          width: "calc(100% - 10px)",
        },
        "& img": {
          objectFit: "cover"
        }
      }
    },
    textWithSpanTitle: {
      "& .title-txts": {
        lineHeight: '1.5',
        marginBottom: 10,
        fontSize: '13px',
        "& > span": {
          display: 'block',
          fontSize: '11px',
          marginBottom: '2px',
          lineHeight: '1',
          color: "#5559"//mode.link,
        }
      }
    },
    txtWithLink: {
      fontSize: ".7em",
      display: "flex",
      alignItems: "center",
      gap: "5px",
      "& span": {
        wordBreak: "break-all"
      },
      "& a": {
        fontSize: ".7em",
        textDecoration: "none",
        display: "inline-block",
        lineHeight: 1,
        "& svg": {
          fontSize: "12px"
        }
      }
    }
  }))


const mapStateToProps = (state: IState) => {
  return ({
    ticketIdWithStatusID: state?.TicketViewReducer?.resolvePopupId,
    statusObj: state?.TicketsReducer?.alldataStructure?.statusTypesById
  })
};

export default connect(mapStateToProps)(ResolvePopup);